class NpProductSlider {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.np-product-slide'));
    this.dots = Array.from(el.querySelectorAll('.np-product-slider__dot'));

    this.current = 0;
    this.transitioning = false;
    this.queued = null;

    if (this.slides.length === 0) return;

    this.el.classList.add('np-product-slider--no-transition');
    this._activate(0);
    requestAnimationFrame(() => {
      this.el.classList.remove('np-product-slider--no-transition');
    });

    this._bindDots();
    this._bindArrows();
    this._bindSwipe();
  }

  _activate(index, forcedDirection) {
    const prev = this.current;
    this.current = index;

    // initial setup (same slide): no animation, and no cleanup timer that could
    // later cut short a real slide started within the first moments after load
    if (index === prev) {
      this.slides[index].classList.add('is-active');
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      return;
    }

    const direction = forcedDirection || (index > prev ? 'forward' : 'backward');

    this.el.dataset.direction = direction;

    // backward: place the incoming slide on the left before it slides in
    if (direction === 'backward' && index !== prev) {
      const incoming = this.slides[index];
      incoming.style.transition = 'none';
      incoming.style.transform = 'translateX(-100%)';
      void incoming.offsetWidth;
      incoming.style.transition = '';
      incoming.style.transform = '';
    }

    this.slides[prev].classList.add('is-prev');
    this.slides[prev].classList.remove('is-active');
    this.slides[index].classList.add('is-active');

    this.slides.forEach((s, i) => {
      if (i !== index && i !== prev) s.classList.remove('is-active', 'is-prev');
    });

    const durationMs =
      (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--slide-duration')) || 0.65) * 1000;

    setTimeout(() => {
      this.slides[prev].style.transition = 'none';
      this.slides[prev].classList.remove('is-prev');
      delete this.el.dataset.direction;
      this.transitioning = false;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        this.slides[prev].style.transition = '';
        // run a click/swipe that arrived during the animation instead of dropping it
        if (this.queued) {
          const [queuedIndex, queuedDirection] = this.queued;
          this.queued = null;
          this._goTo(queuedIndex, queuedDirection);
        }
      }));
    }, durationMs);

    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }

  _goTo(index, direction) {
    if (this.transitioning) {
      // remember only the latest request; it runs when the current slide finishes
      this.queued = [index, direction];
      return;
    }
    if (index === this.current) return;
    this.transitioning = true;
    this._activate(index, direction);
  }

  _bindSwipe() {
    if (this.slides.length < 2) return;
    const track = this.el.querySelector('.np-product-slider__track');
    if (!track) return;

    const threshold = 50;
    let startX = 0;
    let startY = 0;
    let tracking = false;

    track.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      if (!tracking) return;
      tracking = false;

      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < threshold || Math.abs(dx) < Math.abs(dy)) return;

      const count = this.slides.length;
      if (dx < 0) {
        this._goTo((this.current + 1) % count, 'forward');
      } else {
        this._goTo((this.current - 1 + count) % count, 'backward');
      }
    }, { passive: true });

    track.addEventListener('touchcancel', () => (tracking = false), { passive: true });
  }

  _bindDots() {
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this._goTo(i)));
  }

  _bindArrows() {
    const prev = this.el.querySelector('.np-product-slider__arrow--prev');
    const next = this.el.querySelector('.np-product-slider__arrow--next');
    if (prev) prev.addEventListener('click', () => {
      this._goTo((this.current - 1 + this.slides.length) % this.slides.length);
    });
    if (next) next.addEventListener('click', () => {
      this._goTo((this.current + 1) % this.slides.length);
    });
  }
}

document.querySelectorAll('.np-product-slider').forEach((el) => new NpProductSlider(el));
